export default __webpack_public_path__ + "static/media/Icon-material-credit-card.f89fd5fc.svg";